import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'

import Layout from '../components/Layout'

class SiteIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const siteDescription = get(
      this,
      'props.data.site.siteMetadata.description'
    )

    return (
      <Layout>
        <Helmet>
          <title>{siteTitle}</title>
          <meta name="description" content={siteDescription} />
        </Helmet>
        <h2>Miles Robson's Resume</h2>
        <p>
          <strong>
            <a href="mailto:milesdrobson@gmail.com">
              e-mail @ milesdrobson at gmail.com
            </a>
            <span> &#183; </span>
            <a href="https://drive.google.com/open?id=1pxjWYXTxrfItS7vfJbfNjlqsETrIr_OI">
              PDF of Resume
            </a>
          </strong>
        </p>
        <p>
          <strong>WORK EXPERIENCE</strong>
        </p>
        <p>
          <strong>
            National Debt Relief - Staff Salesforce Engineer - (Remote)
          </strong>{' '}
          January 2024 - Current
        </p>
        <ul>
          <li> Introduced a formal Service Cloud case lifecycle for NDR's CS/CX organization, establishing SLA
            governance, case reopening and interruption workflows, backlog visibility, and skill-based work
            management.  </li>
          <li> Re-architected Omni-Channel automation from Flow into Apex to improve transaction control,
            testability, observability, and long-term scalability.  </li>
          <li> Implemented FullStory and Nebula Logger on NDR's external facing Salesforce community for
            faster support and to triage clients facing concerns, creating more proactive awareness of issues
            and incidents.    </li>
          <li> Created a set of polymorphic Lightning Web Components across the Sales organization while
            implementing a net new internal client application process, supported by JEST tests and Copado
            suites, allowing multiple objects and stages to leverage the same set of components.
          </li>
          <li> Designed a department agnostic Apple Messages for Business to be leveraged across Sales and
            Customer Service, following the client's journey across our lifecycle.
          </li>
          <li> Implemented logging, trigger, and service class refactoring enhancements tointernal fflib
            architecture, allowing more proactive transaction time and monitoring across systems, including
            Datadog and internal business unit monitors.
          </li>
          <li> Refining NDR's shared Cursor tooling and engineering instructions to help Salesforce developers
            generate and review code against NDR architecture and coding standards.
          </li>
          <li> Providing architecture review with co-Staff, Leads and Architects, and aid in Gearset and other
            Devops tooling, deployments, and conflict resolution.</li>
        </ul>
        <p></p>
        <p>
          <strong>
            Block - Senior Salesforce Engineer - (Remote)
          </strong>{' '}
          July 2021 - January 2024
        </p>
        <ul>
          <li> Supported 600 cases a second without hitting Service Cloud limitations with an apex automation suite, involving triggers, batchable and invocable apex for declarative developers to enable safe PendingServiceRouting creation for Skill Based Omni routing.</li>
          <li>Mentored and supported a team of 30+ developers and BSAs towards best practices for org health, involving deployment pipeline adjustments, peer reviews on declarative items, automated backups, and local tooling.</li>
          <li>Supported integration of Assembled WFM management tooling and internal transfer team application development for Omnirouting, supporting Cash App's team of 10k users.</li>
          <li>Aiding engineering and other integration partners in navigating the org's landscape, APIs, iframes, scoping out POCs, project possibilities,and implemented custom Apex endpoints for routing requests.</li>
          <li>Engaging with internal enterprise procurement for RFI/RFC support, and implementation support.</li>
        </ul>
        <p></p>
        <p>
          <strong>
            Accenture Federal Services - Senior Salesforce Engineer - (Remote)
          </strong>{' '}
          March 2021 - July 2021
        </p>
        <ul>
          <li>
            Defining and building templates for org-wide standards across multiple projects using fflib, and providing POCs of integrations and other efforts.
          </li>
        </ul>
        <p>
          <strong>
            Gravity Payments - Salesforce Engineer - Seattle, WA (Remote)
          </strong>{' '}
          March 2020 - March 2021
        </p>
        <ul>
          <li>Aided merchant onboarding, customer support, asset management, and ACH chargeback triage processes via Sales, Service, and Platform objects.</li>
          <li>Introduced development lifecycle automation to the internal SFDC platform using Github actions.</li>
          <li>Context based integration updates with Platform Events to an internal lambda for every onboarded merchant to Gravity's custom built client dashboard.</li>
          <li>Rebuilt Gravity's merchant boarding application from legacy Flow into LWC, transforming a 4-hour single-session process into a resumable workflow that allowed sales reps and supporting teams to collaborate across the onboarding lifecycle.</li>
          <li>Utilized Nebula Logger across integration automations for aggressive tracking and error alerting.</li>
          <li>Created accounts payable/receivable integration jobs against Intacct's SOAP API via Apex processing.</li>
        </ul>

        <p>
          <strong>
            Connection Enterprise Solutions - Salesforce Developer - Boca Raton,
            FL
          </strong>{' '}
          July 2018 - March 2020
        </p>

        <ul>
          <li>Handled discovery and development of migration efforts to Lightning, including Visualforce pages translations to Aura Components, various declarative items, Flows and Lightning Quick Actions, and Lightning-Only feature compatibility with business processes.</li>
          <li>Developed LWCs for quick snapshots of a record's health, from open orders on an account, to dollars spent on a given contact, automate SFDC record creation referencing external data systems, creating opportunities off of quote records using internal APIs, to reduce swivel chair across external Progress DB systems.</li>
          <li>Decommissioned external Pentaho ETL batch jobs to internal Salesforce batch Apex jobs with API callouts, error reporting with Platform Events, and notifications to Slack for alerting.</li>
          <li>Omni-channel Live Agent Snap-In development to identify appropriate accounts, contacts, and dynamic routing to related support groups, and explored Einstein Chatbot POCs to aid common support questions.</li>
          <li>Introduced lifecycles with deployment automation using Git, Gerrit, ANT, and SFDX CLI.</li>
        </ul>

        <p>
          <strong>
            Office Depot - Developer, Sales Enablement Team - Boca Raton, FL
          </strong>{' '}
          Sept 2015 - July 2018
        </p>

        <ul>
          <li>Built Visualforce pages for contract summaries of a given account, allowing line level review of SKU pricing, allowing maintenance and adjustments for margins as needed.</li>
          <li>Built Apex REST endpoints for inbound leads from retail stores for SMB opportunities.</li>
          <li>Support of Salesforce batch processes for contract pricing, back-end de-duplication, data quality processes, and automated business rules for customer email notifications.</li>
          <li>Enhancements to Vendavo Compliance and Pricing app, primarily through Vendavo Scripting Language and Vendavo Query Language (VSL/VQL).</li>
          <li>Led initiatives to translate Dataloader shell batch jobs to IBM DataStage ETL and PLSQL jobs.</li>
          <li>Received Office Depot's Q3 2016 Innovation Award for the design, development, and customer response to Vendavo rebate enhancements.</li>
        </ul>

        <p>
          <strong>
            Key Brand Entertainment - Software Developer 1 - Fort Lauderdale, FL
          </strong>{' '}
          May 2015 - Sept 2015
        </p>

        <ul>
          <li>
            Development of RDLC, ASPX, JS, NUnit, WaitIn, and C# WCF services.
          </li>

          <li>
            Experience in MSSQL development, stored procedures and table
            amendments.
          </li>
        </ul>

        <p>
          <strong>Certifications</strong>
        </p>

        <ul>
          <li>Salesforce Platform Developer 1</li>
        </ul>

        <p>
          <strong>SIDE PROJECT WORK</strong>{' '}
          <strong>
            <a href="https://github.com/Confirm4Crit">GitHub</a>
          </strong>
        </p>

        <ul>
          <li>
            <strong>
              <a href="https://github.com/Confirm4Crit/awesome-lwc">
                Awesome-LWC
              </a>
            </strong>
            , a public GitHub repo of resources I help maintain.
          </li>
          <li>This website! GatsbyJS site hosted on Netify</li>

          <li>
            <strong>
              <a href="https://itch.io/queue/c/188585/gamkedo-club?game_id=243394">
                Steel Cavalry
              </a>
            </strong>
            , a mech sidescroller made in Unity as part of{' '}
            <strong>
              <a href="https://gamkedo.com/">Gamkedo</a>
            </strong>{' '}
            club
          </li>

          <li>
            Implemented a binary-encoded image manipulator using Motorola 68000
            assembly language
          </li>
 
          <li>
            Aided in the development of senior aid Android app, managed research
            of falling detection algorithms and implementation, and senior
            usability research.
          </li>
        </ul>

        <p>
          <strong>EDUCATION</strong>
        </p>

        <ul>
          <li>
            Florida Atlantic University – Boca Raton, FL 2013-2015 Bachelor of
            Science in Computer Science
            <ul>
              <li>
                Inducted into Upsilon Pi Epsilon International Computer Science
                Honor Society (Top 10% of class 2014)
              </li>
            </ul>
          </li>
        </ul>
      </Layout>
    )
  }
}

export default SiteIndex

export const query = graphql`
          query {
            site {
            siteMetadata {
            title
        description
      }
    }
  }
          `
